import React, { useEffect, useState } from "react";
import Footer from "../Home/Shard/Footer";
import CategoryBanner from "./CategoryBanner";
import CategoryProfile from "./CategoryProfile";
import Filter from "./Filter";
import SubCategory from "./SubCategory";
import { data } from "./SubcategoryData";

const Category = () => {
  // const { id } = useParams();
  const [categorys, setCategorys] = useState([]);
  useEffect(() => {
    fetch("https://pacific-beach-63189.herokuapp.com/product")
      .then((res) => res.json())
      .then((data) => setCategorys(data));
  }, []);
  console.log(categorys);
  return (
    <div>
      <CategoryBanner />
      <CategoryProfile />
      <div className="container py-5">
        <Filter />
        <hr />
        <div className="row">
          <div className="col-md-5 col-12">
            <h6 className="maptitle">79 stays in map area</h6>
            {data.map((items) => (
              <SubCategory items={items} key={items.id} />
            ))}
          </div>
          <div className="col-md-7 col-12">
            <div className="map">
              <iframe
                title="This is a Dream Fly location"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3651.8990681563923!2d90.37139331434842!3d23.750978394672508!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3755bf4d6018f643%3A0x603d2d083289b4a3!2sDhanmondi%2032%20Road%20Bridge%2C%20Dhanmondi%20Bridge%2C%20Dhaka%201209!5e0!3m2!1sen!2sbd!4v1644859032836!5m2!1sen!2sbd"
                width="100%"
                height="100%"
                style={{ border: "1px solid #e6e6e6", marginTop: "5px" }}
                allowfullscreen=""
                loading="lazy"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Category;
